import { ClassSellingPointApi } from './selling-point-api';

export const sellingPointApiInstance = new ClassSellingPointApi();
